'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   useOutsideClick,
   useBreakpointValue,
   useColorMode,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
// import autoTable from 'jspdf-autotable';
import React, { useState, useRef, useEffect } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import ScreenMasterForm from './ScreenMasterForm';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import DynamicTable from '../../components/DynamicDataTable';
import MobileDataTable from '../../components/MobileDataTable';

// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { useUser } from 'contexts';
//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function ScreenMaster({ columnsData, tableData }) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');
   const [sorting, setSorting] = React.useState([]);
   const [data, setData] = React.useState([...tableData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [focusedInput, setFocusedInput] = React.useState(null);
   const [pageSize, setPageSize] = React.useState(10);
   const [currentPage, setCurrentPage] = React.useState(0);
   const [searchQuery, setSearchQuery] = React.useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const filteredData = React.useMemo(() => {
      if (!searchQuery) return data;
      return data?.filter((row) =>
         columnsData?.some((col) => String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase())),
      );
   }, [data, searchQuery, columnsData]);

   const handleFocus = (id) => setFocusedInput(id);
   const handleBlur = () => setFocusedInput(null);
   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsData.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );
   const isDesktop = useBreakpointValue({ base: false, md: true });
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isEditMode, setIsEditMode] = React.useState(false);

   const { user } = useUser();
   const Admin = user?.isAdmin;

   const companyId = Number(localStorage.getItem('companyId'));
   const screenRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.screen
      : null;

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   // columns.push(
   //    columnHelper.accessor('id', {
   //       id: 'id',
   //       header: () => null,
   //       cell: (info) => (
   //          <Flex justify="end">
   //             <Box className="edit-icon-container">
   //                <IconButton
   //                   aria-label="Edit"
   //                   icon={<EditIcon />}
   //                   variant="ghost"
   //                   colorScheme="brand"
   //                   onClick={() => {
   //                      setCurrentRow(info.row.original);
   //                      setIsEditMode(true);
   //                      onOpen();
   //                   }}
   //                />
   //             </Box>
   //          </Flex>
   //       ),
   //    }),
   // );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = () => {
      if (isEditMode && currentRow) {
         setData(data.map((row) => (row.id === currentRow.id ? currentRow : row)));
      } else if (!isEditMode) {
         setData([...data, { ...currentRow, id: Date.now() }]);
      }
      onClose();
   };

   const downloadPDF = () => {
      const doc = new jsPDF();
      const visibleColumns = columnsData.filter((col) => columnVisibility[col.id]).map((col) => col.header);

      const dataToExport = data.map((row) =>
         visibleColumns.map((header) => row[columnsData.find((col) => col.header === header).id]),
      );

      doc.autoTable({
         head: [visibleColumns],
         body: dataToExport,
      });

      doc.save('data.pdf');
   };

   const downloadExcel = () => {
      const workbook = XLSX.utils.book_new();

      const visibleColumns = columnsData.filter((col) => columnVisibility[col.id]).map((col) => col.header);

      const dataToExport = data.map((row) =>
         visibleColumns.map((header) => row[columnsData.find((col) => col.header === header).id]),
      );

      const worksheetData = [visibleColumns, ...dataToExport];

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      XLSX.writeFile(workbook, 'data.xlsx');
   };

   const handlePageSizeChange = (event) => {
      const value = event.target.value;
      const newPageSize = value === 'ALL' ? data.length : parseInt(value, 10);
      setPageSize(newPageSize);
      setCurrentPage(0); // Reset to first page when changing page size
   };

   const paginatedData = React.useMemo(() => {
      if (pageSize === filteredData.length) return filteredData;
      const start = currentPage * pageSize;
      const end = Math.min(start + pageSize, filteredData.length);
      return filteredData.slice(start, end);
   }, [filteredData, currentPage, pageSize]);

   const totalPages = pageSize === filteredData.length ? 1 : Math.ceil(filteredData.length / pageSize);
   const handlePageChange = (direction) => {
      setCurrentPage((prev) => {
         if (direction === 'next') {
            return Math.min(prev + 1, totalPages - 1);
         } else {
            return Math.max(prev - 1, 0);
         }
      });
   };

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   // Handle search input changes
   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n') {
            if (!isOpen) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen]);

   return (
      <Card
         flexDirection="column"
         w="100%"
         px="0px"
         overflowX={{ sm: 'scroll', lg: 'hidden' }}
         position="relative"
         py="10px"
         borderRadius="7px">
         <Flex
            width={{ base: '100%', md: 'auto' }}
            mb="8px"
            px={{ base: '1px', md: '25px' }}
            justifyContent="space-between"
            align="center"
            overflowX="auto"
            flexWrap="nowrap"
            gap={3}>
            {/* Left Section: Title + Add New Button */}
            <Flex align="center" gap={4} flexShrink={0}>
               <Text
                  color={textColor}
                  ml={{ base: '8px', md: 0 }}
                  fontSize={{ base: '17px', lg: '22px' }}
                  fontWeight="700"
                  lineHeight="100%">
                  Screen
               </Text>
               {!isMobileOrTablet && (Admin || screenRight?.add) && (
                  <button
                     onClick={() => {
                        setCurrentRow({});
                        setIsEditMode(false);
                        onOpen();
                     }}
                     className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                        isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                     }`}>
                     {/* Gradient overlay on hover */}
                     <span
                        className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                           isDark ? 'via-cyan-100/20' : 'via-white/30'
                        }`}></span>

                     {/* Icon container with background */}
                     <span
                        className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                           isDark ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30' : 'bg-white/20 group-hover:bg-white/30'
                        }`}>
                        <svg
                           className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                        </svg>
                     </span>

                     <span className="relative text-base font-semibold">Add New</span>
                  </button>
               )}
            </Flex>
            <Flex>
               <Flex justify="space-between" mb="8px">
                  <Flex align="center">
                     <Box
                        onClick={() => handlePageChange('prev')}
                        cursor={currentPage === 0 || pageSize === filteredData.length ? 'not-allowed' : 'pointer'}
                        opacity={currentPage === 0 || pageSize === filteredData.length ? 0.4 : 1}
                        role="button"
                        aria-label="Previous page">
                        <MdNavigateBefore size={28} />
                     </Box>

                     <Text mx="10px" fontSize={{ base: '14px', lg: '17px' }}>
                        {currentPage + 1}/{totalPages}
                     </Text>

                     <Box
                        onClick={() => handlePageChange('next')}
                        cursor={
                           currentPage >= totalPages - 1 || pageSize === filteredData.length ? 'not-allowed' : 'pointer'
                        }
                        opacity={currentPage >= totalPages - 1 || pageSize === filteredData.length ? 0.4 : 1}
                        role="button"
                        aria-label="Next page">
                        <MdNavigateNext size={28} />
                     </Box>
                  </Flex>
                  <Flex>
                     <Select
                        width="auto"
                        marginRight={5}
                        value={pageSize === filteredData.length ? 'ALL' : pageSize.toString()}
                        onChange={handlePageSizeChange}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="ALL">All</option>
                     </Select>
                     {/* <SearchBar
                        mb={() => {
                           return 'unset';
                        }}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        me="10px"
                        borderRadius="30px"
                     />
                     <Menu
                        onDownloadPDF={downloadPDF}
                        onDownloadExcel={downloadExcel}
                        columnVisibility={columnVisibility}
                        setColumnVisibility={setColumnVisibility}
                     /> */}
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        me="20px"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '200px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        {/* {(expanded || searchQuery !== '') && ( */}
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
                        />
                        {/* )} */}
                        {expanded && (
                           <Input
                              variant="unstyled"
                              // fontSize={15}
                              placeholder="Search..."
                              value={searchQuery}
                              color={icon}
                              // onChange={(e) => setSearchQuery(e.target.value)}
                              onChange={handleSearchChange}
                              autoFocus
                           />
                        )}
                     </MotionFlex>
                     <Menu
                        onDownloadPDF={downloadPDF}
                        onDownloadExcel={downloadExcel}
                        columnVisibility={columnVisibility}
                        setColumnVisibility={setColumnVisibility}
                     />
                     {/* <Button
            onClick={() => {
              setCurrentRow({});
              setIsEditMode(false);
              onOpen();
            }}
            variant="darkBrand"
            color="white"
            fontSize="sm"
            fontWeight="500"
            borderRadius="full"
            position="fixed"
            bottom="20px"
            right="20px"
            p={6}
            zIndex={100}
          >
            Add New
          </Button> */}
                  </Flex>
                  {isMobileOrTablet && (Admin || screenRight?.add) && (
                     <Box position="fixed" bottom="4" right="4" zIndex={999}>
                        <button
                           onClick={() => {
                              setCurrentRow({});
                              setIsEditMode(false);
                              onOpen();
                           }}
                           className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                              isDark
                                 ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                                 : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                           {/* Gradient overlay on hover */}
                           <span
                              className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                                 isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                           {/* Icon container with background */}
                           <span
                              className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                                 isDark
                                    ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                    : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                              <svg
                                 className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                                 fill="none"
                                 stroke="currentColor"
                                 viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.5"
                                    d="M12 4v16m8-8H4"
                                 />
                              </svg>
                           </span>

                           <span className="relative text-base font-semibold">Add New</span>
                        </button>
                     </Box>
                  )}
               </Flex>
            </Flex>
         </Flex>

         {/* Table Rendering */}
         {/* {isDesktop ? ( */}
         <DynamicTable
            singleEntityRights={screenRight}
            table={table}
            tableData={paginatedData}
            filter={filter}
            emptyMessage="No screen data found"
            onEditClick={(row) => {
               setCurrentRow(row);
               setIsEditMode(true);
               onOpen();
            }}
            onDeleteClick={(id) => {
               handleDeleteClick(id);
            }}
            canDelete={false}
            columnVisibility={columnVisibility}
         />
         {/* ) : (
            <MobileDataTable
               data={data}
               customerRight={screenRight}
               onEditClick={(row) => {
                  setCurrentRow(row);
                  setIsEditMode(true);
                  onOpen();
                  setIsOpenSingleView(false);
               }}
               onDeleteClick={(id) => {
                  handleDeleteClick(id);
                  setIsOpenSingleView(false);
               }}
               emptyMessage={'No screen data found'}
            />
         )} */}

         <ScreenMasterForm
            isOpen={isOpen}
            onClose={onClose}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />

         <style jsx>{`
            .editable-row {
               position: relative;
               background: ${useColorModeValue('white', 'gray.700')};
               transition: background 0.3s ease;
            }

            .editable-row:hover {
               background: ${useColorModeValue('gray.100', 'gray.600')};
            }

            .editable-row .edit-icon-container {
               display: none;
            }

            .editable-row:hover .edit-icon-container {
               display: block;
               position: absolute;
               right: 10px;
               top: 50%;
               transform: translateY(-50%);
            }
         `}</style>
      </Card>
   );
}
